import {
  type RouteObject,
} from "react-router";
import StateAliasApp from "statealias/app";

declare let viewModel: any;

export const stateAliasRoute: RouteObject = {
  path: "statealias",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: StateAliasApp,
  }]
};